import { LineClose } from '@qr-front/icons/line-close'
import { LineLogOut } from '@qr-front/icons/line-log-out'
import { LineMenu } from '@qr-front/icons/line-menu'
import { Separator } from '@qr-front/ui/components/Separator'
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetDescription,
	SheetFooter,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from '@qr-front/ui/components/Sheet'
import { cn } from '@qr-front/ui/utils'
import { logOut } from 'features/auth/utils/logOut'
import { qrSvgPromiseCache } from 'features/library/client'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { LogoLink } from '@/components/LogoLink/LogoLink'
import { Link, usePathname } from '@/i18n-routing'

import { useGatedNavigation } from '../hooks/useGatedNavigation'
import {
	sidebarFooterLinkGroup,
	sidebarLinkGroup,
} from './PrivateLayoutSidebar'

const sheetContentItems = [...sidebarLinkGroup, ...sidebarFooterLinkGroup]

const LibrarySheetLinks = ({
	setIsOpen,
}: {
	setIsOpen: (isOpen: boolean) => void
}) => {
	const pathname = usePathname()
	const t = useTranslations()

	const handleGatedNavigation = useGatedNavigation()

	return (
		<ul className="my-5 flex flex-col pt-4">
			{sheetContentItems.map(
				(item, index) =>
					item.url && (
						<li
							key={item.url}
							className={cn(
								'type-body-medium cursor-pointer py-5 text-dark-grey',
								index !== sidebarLinkGroup.length &&
									'-mt-px border-b border-b-border-grey-50',
							)}
						>
							<Link
								href={item.url}
								onClick={(event) => {
									handleGatedNavigation(event, item.url)
									setIsOpen(false)
								}}
								className={cn(
									'flex items-center gap-4 p-2 word-break-fix active:text-blue hover:text-blue',
									item.url === pathname
										? 'text-blue'
										: 'text-dark-grey',
								)}
							>
								<item.icon className="shrink-0" />
								{t(item.title)}
							</Link>
						</li>
					),
			)}
		</ul>
	)
}

export const PrivateLayoutMobileSheet = () => {
	const t = useTranslations()

	const [isOpen, setIsOpen] = useState(false)

	const handleLogout = async () => {
		qrSvgPromiseCache.clear()
		await logOut()
	}

	return (
		<div className="flex items-center gap-4 desktop:hidden">
			<Sheet open={isOpen} onOpenChange={setIsOpen}>
				<SheetTrigger>
					<LineMenu className="cursor-pointer active:text-blue hover:text-blue" />
				</SheetTrigger>
				<SheetContent className="h-dvh">
					<SheetHeader className="flex items-center justify-between pt-4">
						<LogoLink isDisabled />
						<SheetTitle aria-describedby={undefined}></SheetTitle>
						<SheetDescription
							aria-describedby={undefined}
						></SheetDescription>
						<SheetClose>
							<LineClose className="cursor-pointer" />
						</SheetClose>
					</SheetHeader>
					<div className="min-h-0 flex-1 overflow-y-auto">
						<LibrarySheetLinks setIsOpen={setIsOpen} />
					</div>
					<SheetFooter className="mt-auto py-5">
						<Separator collapse className="my-5" />
						<SheetClose asChild>
							<button
								className="flex w-full items-center gap-4 p-2 text-left outline-none word-break-fix hover:text-blue"
								onClick={handleLogout}
							>
								<LineLogOut className="shrink-0" />
								{t('dashboard__sidebar__link_groups__logout')}
							</button>
						</SheetClose>
						<div className="h-safe-area-bottom" />
					</SheetFooter>
				</SheetContent>
			</Sheet>
		</div>
	)
}
